import {
  // Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
} from '@mui/material';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormFileUploadField from 'components/ui/form/FormFileUploadField';
import FormTextField from 'components/ui/form/FormTextField';
import FormSelectField from 'components/ui/form/FormSelectField';
import useFormSubmit from 'hooks/useFormSubmit';
// import { useState } from 'react';

const validationSchema = yup.object({
  name: yup
    .string()
    .min(4, { label: 'block.imageAddEditModal.validation.nameMin', value: 4 })
    .required('block.imageAddEditModal.validation.name'),
  object_id: yup.number().required('block.addModal.validation.objectId'),
  image: yup.mixed().nullable(),
  image2d: yup.mixed().nullable(),
  location: yup.mixed().nullable(),
  visual: yup.mixed().nullable(),
});

const BlockAddEditImageModal = (props) => {
  const { open, setOpen, setSelected, itemData, refetchFn = () => {} } = props;
  const { t } = useTranslation();
  const { submit, isSubmitting } = useFormSubmit();
  const getName = (str) => {
    if (!str) return null;
    const words = str.split('/');
    return words?.at(-1);
  };

  const formik = useFormik({
    initialValues: {
      name: itemData?.name || '',
      object_id: itemData?.object_id || '',
      image: getName(itemData?.link) || null,
      image2d: getName(itemData?.link2d) || null,
      location: getName(itemData?.location) || null,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const body = Object.fromEntries(
        Object.entries(values)?.map(([a, b]) =>
          a !== 'name' ? (typeof b == 'string' ? [a, null] : [a, b]) : [a, b]
        )
      );
      if (itemData && itemData?.id) {
        submit(
          { type: 'postUpdate', contentType: 'formData' },
          body,
          '/admin/plan',
          {
            title: t('block.imageAddEditModal.alerts.success', {
              objectName: itemData?.objects?.name,
              blockName: itemData?.name,
            }),
          },
          itemData?.id,
          false,
          handleFinish
        );
      } else {
        submit(
          { type: 'post', contentType: 'formData' },
          body,
          '/admin/plan',
          {
            title: t('block.imageAddEditModal.alerts.success', {
              objectName: itemData?.objects?.name,
              blockName: itemData?.name,
            }),
          },
          null,
          false,
          handleFinish
        );
      }
    },
  });

  const handleFinish = () => {
    refetchFn();
    handleClose();
  };

  const handleClose = () => {
    setOpen(false);
    setSelected({});
    formik.resetForm();
  };

  // save by folder multiply

  // const [files, setFiles] = useState([]);

  // const handleFolderSelect = (event) => {
  //   const selectedFiles = Array.from(event.target.files);

  //   const grouped = {};
  //   selectedFiles.forEach((file) => {
  //     const folderName = file.webkitRelativePath.split('/')[1];
  //     if (!grouped[folderName]) grouped[folderName] = null;
  //     grouped[folderName] = file;
  //   });

  //   const result = [];
  //   const object_id = 1;
  //   const allFiles = Object.values(grouped);
  //   const folderName = allFiles[0]?.webkitRelativePath.split('/')[0] || 'a';

  //   for (let i = 1; i <= selectedFiles?.length / 2; i++) {
  //     const image2dName = `2d-${i}.png`;
  //     const locationName = `location-${i}.png`;

  //     if (grouped[image2dName] && grouped[locationName]) {
  //       result.push({
  //         name: `milliard-${folderName}-1-${i}`,
  //         object_id,
  //         image2d: grouped[image2dName],
  //         location: grouped[locationName],
  //       });
  //     } else {
  //       console.warn(
  //         `⚠️ Juftlik topilmadi: ${image2dName} yoki ${locationName}`
  //       );
  //     }
  //   }

  //   setFiles(result);
  // };

  // const handleSaveData = (data) => {
  //   submit(
  //     { type: 'post', contentType: 'formData' },
  //     data,
  //     '/admin/plan',
  //     {
  //       title: t('block.imageAddEditModal.alerts.success', {
  //         objectName: itemData?.objects?.name,
  //         blockName: itemData?.name,
  //       }),
  //     },
  //     null,
  //     false,
  //     () => {}
  //   );
  // };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      disableEscapeKeyDown={true}
      PaperProps={{
        className: '!base-border !shadow-none',
      }}
    >
      <DialogTitle id='alert-dialog-title' className='text-center !bg-gray-100'>
        {itemData && itemData?.id ? (
          <span>
            {t('block.imageAddEditModal.editTitle', {
              value: itemData?.name,
            })}
          </span>
        ) : (
          <span>{t('block.imageAddEditModal.addTitle')}</span>
        )}
        {/* save by folder multiply */}

        {/* <input
          type='file'
          webkitdirectory='true'
          directory=''
          multiple
          onChange={handleFolderSelect}
        /> */}
      </DialogTitle>

      <DialogContent>
        <div className='py-3 max-w-[700px]'>
          {/* save by folder multiply */}

          {/* {files?.map((data, i) => (
            <Button
              variant='base'
              key={i}
              color='success'
              className='!ml-2'
              onClick={() => handleSaveData(data)}
            >
              <i className='bi bi-plus-circle' />!
            </Button>
          ))} */}
          <form onSubmit={formik.handleSubmit}>
            <Grid
              container
              spacing={{ xs: 2, sm: 3, lg: 3 }}
              rowSpacing={1}
              columns={{ xs: 12, sm: 12, lg: 12 }}
            >
              <Grid item={true} sm={6} xs={12}>
                <div className='-mb-1 text-gray-600 text-sm'>
                  {t('common.fields.objectName')}
                </div>
                <FormSelectField
                  delay={0}
                  fieldName='object_id'
                  placeholder={t('common.fields.objectName')}
                  formik={formik}
                  path={'/dictionary/objects2'}
                  isitemsizesmall={true}
                />
              </Grid>
              <Grid item={true} sm={6} xs={12}>
                <div className='-mb-1 text-gray-600 text-sm'>
                  {t('common.fields.planName')}
                </div>
                <FormTextField
                  delay={0.001}
                  placeholder={t('common.fields.planName')}
                  fieldName='name'
                  formik={formik}
                />
              </Grid>

              <Grid item={true} sm={6} xs={12}>
                <div className='-mb-1 text-gray-600 text-sm'>
                  {t('block.imageAddEditModal.uploadPlan2D')}
                </div>
                <FormFileUploadField
                  delay={0.0012}
                  accept='.jpg, .png'
                  fieldName='image2d'
                  formik={formik}
                  label={t('common.fields.plan2D')}
                  btnLabel={t('block.imageAddEditModal.uploadPlan2D')}
                  fileSize={1}
                />
              </Grid>

              <Grid item={true} sm={6} xs={12}>
                <div className='-mb-1 text-gray-600 text-sm'>
                  {t('block.imageAddEditModal.uploadPlan3D')}
                </div>
                <FormFileUploadField
                  delay={0.0013}
                  accept='.jpg, .png'
                  fieldName='image'
                  formik={formik}
                  label={t('common.fields.plan3D')}
                  btnLabel={t('block.imageAddEditModal.uploadPlan3D')}
                  fileSize={1}
                />
              </Grid>
              <Grid item={true} sm={6} xs={12}>
                <div className='-mb-1 text-gray-600 text-sm'>
                  {t('block.imageAddEditModal.uploadLocation')}
                </div>
                <FormFileUploadField
                  delay={0.0014}
                  accept='.jpg, .png'
                  fieldName='location'
                  formik={formik}
                  label={t('common.fields.location')}
                  btnLabel={t('block.imageAddEditModal.uploadLocation')}
                  fileSize={1}
                />
              </Grid>
              <Grid item={true} sm={6} xs={12}>
                <div className='-mb-1 text-gray-600 text-sm'>
                  {t('block.imageAddEditModal.uploadVisual')}
                </div>
                <FormFileUploadField
                  delay={0.0014}
                  accept='.glb'
                  fieldName='visual'
                  formik={formik}
                  label={t('common.fields.visual')}
                  btnLabel={t('block.imageAddEditModal.uploadVisual')}
                  fileSize={1}
                />
              </Grid>

              <Grid item={true} sm={12} xs={12}>
                <FormActionButtons
                  delay={0.4}
                  isSubmitting={isSubmitting}
                  formType='dialog'
                  setOpen={setOpen}
                  reset={formik.resetForm}
                />
              </Grid>
            </Grid>
          </form>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default BlockAddEditImageModal;
